import {
  CONTENT_LOGS_DIR_FETCH_REQUEST,
  CONTENT_LOGS_DIR_FETCH_SUCCESS,
  CONTENT_LOGS_DIR_FETCH_FAILURE,
  CONTENT_LOGS_FILE_FETCH_REQUEST,
  CONTENT_LOGS_FILE_FETCH_SUCCESS,
  CONTENT_LOGS_FILE_FETCH_FAILURE,
} from '../../types';
import { listContentLogsDirApi, readContentLogFileApi } from '../../api/contentLogs';

export const fetchContentLogsDir = (dirPath: string) => async (dispatch: any) => {
  dispatch({ type: CONTENT_LOGS_DIR_FETCH_REQUEST, payload: dirPath });
  try {
    const response = await listContentLogsDirApi(dirPath);
    dispatch({ type: CONTENT_LOGS_DIR_FETCH_SUCCESS, payload: { entries: response.data, path: dirPath } });
  } catch (error) {
    const err = error as any;
    dispatch({
      type: CONTENT_LOGS_DIR_FETCH_FAILURE,
      payload: err?.response?.data?.message || 'Failed to fetch directory',
    });
  }
};

export const fetchContentLogFile = (filePath: string) => async (dispatch: any) => {
  dispatch({ type: CONTENT_LOGS_FILE_FETCH_REQUEST });
  try {
    const response = await readContentLogFileApi(filePath);
    dispatch({ type: CONTENT_LOGS_FILE_FETCH_SUCCESS, payload: response.data });
  } catch (error) {
    const err = error as any;
    dispatch({
      type: CONTENT_LOGS_FILE_FETCH_FAILURE,
      payload: err?.response?.data?.message || 'Failed to fetch file',
    });
  }
};
